// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/slick-carousel/slick/slick-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-details-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.back-button {
  position: fixed;
  top: 15px;
  left: calc((100% - 600px) / 2 + 20px);
  background: transparent;
  border: none;
  font-size: 30px;
  cursor: pointer;
  color: #000;
  font-weight: bold;
  padding: 0;
  z-index: 10;
}

.project-details-content {
  text-align: center;
  padding-top: 40px;
}

.profile-section-detail {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: flex-start;
}

.profile-picture-detail {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  margin-right: 15px;
}

.profile-name-detail {
  font-size: 20px;
  font-weight: bold;
}

.image-section {
  margin-bottom: 20px;
}

.project-main-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.project-title-description {
  text-align: left;
  margin-top: 20px;
}

.project-title {
  font-size: 20px;
  font-weight: bold;
}

.project-description {
  font-size: 12px;
  color: #333;
  line-height: 1.6;
  margin-top: 10px;
}

.project-carousel {
  width: 100%;
  overflow: hidden;
}

.project-carousel .slick-slide img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.slick-prev, .slick-next {
  width: 50px;
  height: 0px;
  border-radius: 50%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  cursor: pointer;
}

.slick-prev:before {
  content: '<';
  font-family: Arial, sans-serif;
  font-size: 30px;
  color: #000;
}

.slick-next:before {
  content: '>';
  font-family: Arial, sans-serif;
  font-size: 30px;
  color: #000;
}

.slick-prev {
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.slick-next {
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.slick-dots {
  bottom: 15px;
  display: flex !important;
  justify-content: center;
}

.slick-dots li {
  margin: 0 0px;
}

.slick-dots li button:before {
  font-size: 10px;
}

@media (max-width: 600px) {
  .project-details-container {
    padding: 10px;
  }

  .profile-picture {
    width: 60px;
    height: 60px;
  }

  .profile-name {
    font-size: 20px;
  }

  .project-title {
    font-size: 20px;
  }

  .project-description {
    font-size: 12px;
  }

  .back-button {
    left: 10px;
    font-size: 30px;
    top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/ProjectDetails.css"],"names":[],"mappings":"AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,qCAAqC;EACrC,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":["@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n\n.project-details-container {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.back-button {\n  position: fixed;\n  top: 15px;\n  left: calc((100% - 600px) / 2 + 20px);\n  background: transparent;\n  border: none;\n  font-size: 30px;\n  cursor: pointer;\n  color: #000;\n  font-weight: bold;\n  padding: 0;\n  z-index: 10;\n}\n\n.project-details-content {\n  text-align: center;\n  padding-top: 40px;\n}\n\n.profile-section-detail {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  justify-content: flex-start;\n}\n\n.profile-picture-detail {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: none;\n  margin-right: 15px;\n}\n\n.profile-name-detail {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.image-section {\n  margin-bottom: 20px;\n}\n\n.project-main-image {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.project-title-description {\n  text-align: left;\n  margin-top: 20px;\n}\n\n.project-title {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.project-description {\n  font-size: 12px;\n  color: #333;\n  line-height: 1.6;\n  margin-top: 10px;\n}\n\n.project-carousel {\n  width: 100%;\n  overflow: hidden;\n}\n\n.project-carousel .slick-slide img {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.slick-prev, .slick-next {\n  width: 50px;\n  height: 0px;\n  border-radius: 50%;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 36px;\n  cursor: pointer;\n}\n\n.slick-prev:before {\n  content: '<';\n  font-family: Arial, sans-serif;\n  font-size: 30px;\n  color: #000;\n}\n\n.slick-next:before {\n  content: '>';\n  font-family: Arial, sans-serif;\n  font-size: 30px;\n  color: #000;\n}\n\n.slick-prev {\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.slick-next {\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.slick-dots {\n  bottom: 15px;\n  display: flex !important;\n  justify-content: center;\n}\n\n.slick-dots li {\n  margin: 0 0px;\n}\n\n.slick-dots li button:before {\n  font-size: 10px;\n}\n\n@media (max-width: 600px) {\n  .project-details-container {\n    padding: 10px;\n  }\n\n  .profile-picture {\n    width: 60px;\n    height: 60px;\n  }\n\n  .profile-name {\n    font-size: 20px;\n  }\n\n  .project-title {\n    font-size: 20px;\n  }\n\n  .project-description {\n    font-size: 12px;\n  }\n\n  .back-button {\n    left: 10px;\n    font-size: 30px;\n    top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
